import type {
  AddCartClickedAttributes,
  CartLoadedAttributes,
  CategoryDetailsLoadedAttributes,
  ProductChoiceOpenedAttributes,
  ProductImpressionsLoadedAttributes,
  RemoveCartClickedAttributes,
  ShopDetailsLoadedAttributes,
  SubCategoryDetailsClickedAttributes,
  SwimlaneSwipedAttributes,
  SwimlanesLoadedAttributes,
  ViewAllClickedAttributes,
} from '@glovo/perseus-events-perseus'
import {
  AddCartClicked,
  CartLoaded,
  CategoryDetailsLoaded,
  PageType,
  ProductChoiceOpened,
  ProductImpressionsLoaded,
  RemoveCartClicked,
  ShopDetailsLoaded,
  SubCategoryDetailsClicked,
  SwimlaneSwiped,
  SwimlanesLoaded,
  ViewAllClicked,
} from '@glovo/perseus-events-perseus'

export const AddCartClickedEvent = (attributes: AddCartClickedAttributes) =>
  new AddCartClicked({ ...attributes, pageType: PageType.ShopDetails })

export const CartLoadedEvent = (attributes: CartLoadedAttributes) =>
  new CartLoaded({ ...attributes, pageType: PageType.ShopDetails })

export const CategoryDetailsLoadedEvent = (attributes: CategoryDetailsLoadedAttributes) =>
  new CategoryDetailsLoaded({ ...attributes, pageType: PageType.ShopDetails })

export const ProductChoiceOpenedEvent = (attributes: ProductChoiceOpenedAttributes) =>
  new ProductChoiceOpened({ ...attributes, pageType: PageType.ShopDetails })

export const ProductImpressionsLoadedEvent = (attributes: ProductImpressionsLoadedAttributes) =>
  new ProductImpressionsLoaded({ ...attributes, pageType: PageType.ShopDetails })

export const RemoveCartClickedEvent = (attributes: RemoveCartClickedAttributes) =>
  new RemoveCartClicked({ ...attributes, pageType: PageType.ShopDetails })

export const ShopDetailsLoadedEvent = (attributes: ShopDetailsLoadedAttributes) =>
  new ShopDetailsLoaded({ ...attributes, pageType: PageType.ShopDetails })

export const SubCategoryDetailsClickedEvent = (attributes: SubCategoryDetailsClickedAttributes) =>
  new SubCategoryDetailsClicked({ ...attributes, pageType: PageType.ShopDetails })

export const SwimlaneSwipedEvent = (attributes: SwimlaneSwipedAttributes) =>
  new SwimlaneSwiped({ ...attributes, pageType: PageType.ShopDetails })

export const SwimlanesLoadedEvent = (attributes: SwimlanesLoadedAttributes) =>
  new SwimlanesLoaded({ ...attributes, pageType: PageType.ShopDetails })

export const ViewAllClickedEvent = (attributes: ViewAllClickedAttributes) =>
  new ViewAllClicked({ ...attributes, pageType: PageType.ShopDetails })
